/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i[_ngcontent-%COMP%]{font-size:68px;color:#9ca4a6}*[_ngcontent-%COMP%]{color:#9ca4a6}h4[_ngcontent-%COMP%]{font-size:18px;font-weight:700}.icon-container[_ngcontent-%COMP%]{margin-top:40px;width:100%;display:flex;justify-content:center;margin-bottom:24px}"];
export { styles as styles };
